import { createContext, type ReactNode, useCallback, useContext, useEffect, useState } from 'react'

export const SIDEBAR_COLLAPSED_KEY = 'porotutu.react-sidebar-collapsed'

export function storedSidebarCollapsed(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true'
  } catch {
    return false
  }
}

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(storedSidebarCollapsed)

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed))
    } catch {}
  }, [collapsed])

  const toggle = useCallback(() => setCollapsed((prev) => !prev), [])

  return { collapsed, toggle }
}

const SidebarCollapsedContext = createContext(false)

export function SidebarCollapsedProvider({
  collapsed,
  children,
}: {
  collapsed: boolean
  children: ReactNode
}) {
  return (
    <SidebarCollapsedContext.Provider value={collapsed}>
      {children}
    </SidebarCollapsedContext.Provider>
  )
}

export const useIsSidebarCollapsed = () => useContext(SidebarCollapsedContext)
